import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.scss';
import { ArrowUp } from 'react-feather';
import ReactGA from 'react-ga';



// Import Pages
import Header from './components/Header';
import Footer from './components/Footer'
import Home from './Pages/Homepage';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Projects from './Pages/ProjectsPage';
import Services from './Pages/Services';
import Culture from './Pages/Culture';
import TnC from './Pages/TnC';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ScrollToTop from './helper/helper';
import NotFound from './Pages/NotFound';
import PfizerKeepItReal from './Sections/SingleProject/PfizerKeepItReal';
import Spectra from './Sections/SingleProject/Spectra';
import GoDaddy from './Sections/SingleProject/GoDaddy';
import Upes from './Sections/SingleProject/Upes';
import MyCamsApp from './Sections/SingleProject/MyCamsApp';


ReactGA.initialize('UA-177131508-1');

function App() {

  // Scroll to top button
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true)
    }
    else if (scrolled <= 300) {
      setVisible(false)
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisible);
  // Scroll to top button

  useEffect(()=>{
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []); 

  return (
    <Router basename={'/organic'}>
      <div className='App'>
        <Header />
        <main>
          <div className='empty-class'></div>
          <ScrollToTop />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about-us" component={About} />
            <Route exact path="/our-work" component={Projects} />
            <Route exact path="/pfizer-keep-it-real" component={PfizerKeepItReal} />
            <Route exact path="/spectra-draw-the-line" component={Spectra} />
            <Route exact path="/godaddy-india" component={GoDaddy} />
            <Route exact path="/upes-shakti" component={Upes} />
            <Route exact path="/my-cams-app" component={MyCamsApp} />
            <Route exact path="/contact-us" component={Contact} />
            <Route exact path="/services" component={Services} />
            <Route exact path="/our-culture" component={Culture} />
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route exact path="/terms-and-conditions" component={TnC} />
            <Route path="*" component={NotFound} />
          </Switch>
          <Footer />
        </main>
      </div>
      <button className='scrollToTop' onClick={scrollToTop} style={{ display: visible ? 'inline' : 'none' }}><ArrowUp /></button>
    </Router>
  );
}

export default App;
